// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { PropsWithChildren, useMemo } from 'react';
import { useConfig } from '../hooks/other/useConfig';
import usePrimaryParty from '../hooks/queries/usePrimaryParty';
import { PartiesContext } from './PartiesContext';
import { useBridgeOperatorParty} from '../hooks/queries/useBridgeOperatorParty';
import { useUtilityOperatorParty } from '../hooks/queries/useOperatorParty';

export const PartiesProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const config = useConfig();

  const party = usePrimaryParty()?.data || '';
  const operator = useUtilityOperatorParty()?.data || '';
  const bridgeOperator = useBridgeOperatorParty()?.data || '';
  const crossChainRepresentative = config.crossChainRepresentative || '';

  const value = useMemo(
    () => ({ operator, party, bridgeOperator, crossChainRepresentative }),
    [operator, party, bridgeOperator, crossChainRepresentative],
  );

  return <PartiesContext.Provider value={value}>{children}</PartiesContext.Provider>;
};
